/**
 * Typesense Search - Standalone Vanilla JS Version
 * Direct Typesense REST API calls without InstantSearch.js
 * ~15KB vs ~50KB with InstantSearch
 */

(function() {
  'use strict';

  if (window.typesenseSearchInitialized) return;
  window.typesenseSearchInitialized = true;

  // Build config: prefer data-* attributes on the wrapper, then an explicit
  // window.TYPESENSE_CONFIG global (legacy), then hardcoded defaults.
  const wrapperEl = document.getElementById('typesense-search-wrapper');
  const ds = (wrapperEl && wrapperEl.dataset) || {};
  const defaults = {
    host: 'sitmkeaj1fguc7z8p-1.a1.typesense.net',
    port: '443',
    protocol: 'https',
    apiKey: '',   // comes from the theme setting via data-ts-api-key; never hardcode it here
    collection: 'products_v3',
    shopUrl: window.location.origin,
    placeholder: 'Zoek producten...',
    minChars: 1,
    resultsPerPage: 20
  };
  const config = Object.assign({}, defaults, window.TYPESENSE_CONFIG || {}, {
    host: ds.tsHost || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.host) || defaults.host,
    port: '443',
    protocol: 'https',
    apiKey: ds.tsApiKey || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.apiKey) || defaults.apiKey,
    collection: ds.tsCollection || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.collection) || defaults.collection,
    shopUrl: ds.tsShopUrl || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.shopUrl) || defaults.shopUrl,
    placeholder: ds.tsPlaceholder || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.placeholder) || defaults.placeholder,
    minChars: parseInt(ds.tsMinChars, 10) || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.minChars) || defaults.minChars,
    resultsPerPage: parseInt(ds.tsResultsPerPage, 10) || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.resultsPerPage) || defaults.resultsPerPage,
    pcardStyle: ds.tsPcardStyle || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.pcardStyle) || 'standard',
    pcardColorScheme: ds.tsPcardColorScheme || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.pcardColorScheme) || 'scheme-1',
    pcardTitleLineLimit: ds.tsPcardTitleLineLimit || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.pcardTitleLineLimit) || 'none',
    assetBaseUrl: ds.tsAssetBaseUrl || (window.TYPESENSE_CONFIG && window.TYPESENSE_CONFIG.assetBaseUrl) || ''
  });
  if (!config.apiKey) {
    console.error('Typesense Search: API key missing. Set it in theme settings > Search input > Typesense.');
    return;
  }
  // Track last search query for analytics events
  let lastSearchQuery = '';
  const minTrackedSearchChars = Math.max(config.minChars, 3);
  let lastTrackedSearchEventKey = '';

  // Anonymous user ID for analytics aggregation
  const getUserId = () => {
    if (window.__st?.cid) return String(window.__st.cid);
    let id = sessionStorage.getItem('ts_uid');
    if (!id) {
      id = 'anon_' + Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem('ts_uid', id);
    }
    return id;
  };

  // ===== ANALYTICS EVENTS =====

  const sendAnalyticsEvent = (type, name, data) => {
    fetch(`${config.protocol}://${config.host}:${config.port}/analytics/events`, {
      method: 'POST',
      headers: {
        'X-TYPESENSE-API-KEY': config.apiKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ type, name, data }),
      // The click on a result navigates away; keepalive lets the request finish after unload.
      keepalive: true,
    }).catch(() => {});
  };

  const trackProductClick = (docId) => {
    if (!lastSearchQuery || !docId) return;
    sendAnalyticsEvent('click', 'products_click_event', {
      q: lastSearchQuery,
      doc_id: String(docId),
      user_id: getUserId(),
    });
  };

  // ===== GTM DATALAYER HELPERS =====

  const pushToDataLayer = (eventName, eventData) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventData });
  };

  const searchWrapper = document.getElementById('typesense-search-wrapper');
  const searchInput = document.getElementById('typesense-search-input');
  const resultsContainer = document.getElementById('typesense-results-container');
  const hitsContainer = document.querySelector('#ts-hits-container .search-hits-list');
  const statsContainer = document.getElementById('ts-stats-container');
  const viewAllContainer = document.getElementById('ts-view-all-container');
  const suggestionsContainer = document.getElementById('ts-suggestions-container');
  const collectionsContainer = document.getElementById('ts-collections-container');
  const categoriesList = document.getElementById('ts-categories-list');
  const brandsList = document.getElementById('ts-brands-list');
  const closeButtonDesktop = document.getElementById('ts-close-btn-desktop');
  const closeButtonMobile = document.querySelector('.ts-close-button--mobile');
  const resetButton = document.querySelector('.ts-search-reset');

  if (!searchInput || !resultsContainer) {
    console.warn('Typesense Search: Required elements not found');
    return;
  }

  // ===== UTILITY FUNCTIONS =====

  const escapeHtml = (str) => {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  };

  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[ëï]/g, 'e')
      .trim();
  };

  const trackSearchResultsView = debounce((query, count) => {
    const normalizedQuery = normalizeText(query);
    if (!normalizedQuery || normalizedQuery.length < minTrackedSearchChars) return;

    const activeQuery = normalizeText(searchInput?.value || '');
    if (activeQuery !== normalizedQuery) return;

    const eventKey = `${normalizedQuery}:${count}`;
    if (lastTrackedSearchEventKey === eventKey) return;

    lastTrackedSearchEventKey = eventKey;
    pushToDataLayer('view_search_results', {
      search_term: query,
      search_results_count: count
    });
  }, 450);

  // ===== SMART CATEGORY MATCHING =====

  const categorySynonyms = {
    'vitamine': ['vitamine', 'vitamines', 'vitaminen'],
    'mineraal': ['mineraal', 'mineralen'],
    'supplement': ['supplement', 'supplementen'],
    'capsule': ['capsule', 'capsules'],
    'tablet': ['tablet', 'tabletten'],
    'poeder': ['poeder', 'poeders'],
    'olie': ['olie', 'oliën'],
    'proteïne': ['proteïne', 'proteine', 'protein', 'eiwitten', 'eiwit'],
    'aminozuur': ['aminozuur', 'aminozuren', 'amino'],
    'kruid': ['kruid', 'kruiden'],
    'thee': ['thee', 'theeën', 'tea'],
    'sportvoeding': ['sportvoeding', 'sport', 'fitness'],
    'biologisch': ['biologisch', 'biologische', 'bio', 'organic'],
    'vegan': ['vegan', 'veganistisch', 'plantaardig', 'plant-based'],
    'omega': ['omega', 'visolie', 'fish oil'],
    'probiotica': ['probiotica', 'probioticum', 'probiotic'],
    'magnesium': ['magnesium', 'mg'],
    'calcium': ['calcium', 'ca'],
    'zink': ['zink', 'zinc'],
    'ijzer': ['ijzer', 'iron', 'fe'],
    'b12': ['b12', 'b-12', 'cobalamine'],
    'd3': ['d3', 'd-3', 'cholecalciferol'],
    'c': ['vitamine c', 'c', 'ascorbinezuur'],
  };

  const categoryIntents = {
    'biologisch': ['biologisch', 'bio', 'organic'],
    'vegan': ['vegan', 'plantaardig', 'plant-based'],
    'sport': ['sport', 'fitness', 'workout', 'training'],
    'afvallen': ['afvallen', 'gewichtsverlies', 'dieet'],
    'slapen': ['slapen', 'slaap', 'rust', 'melatonine'],
    'energie': ['energie', 'vermoeidheid', 'moe'],
    'weerstand': ['weerstand', 'immuun', 'afweer'],
    'huid': ['huid', 'haar', 'nagels', 'beauty'],
    'gewrichten': ['gewrichten', 'gewricht', 'mobiliteit'],
    'spieren': ['spier', 'spieren', 'muscle'],
    'darmen': ['darm', 'darmen', 'maag', 'spijsvertering'],
    'hart': ['hart', 'cardiovasculair', 'bloedvaten'],
    'hersenen': ['hersenen', 'concentratie', 'focus', 'geheugen'],
    'ogen': ['ogen', 'zicht', 'vision'],
    'botten': ['botten', 'bot', 'calcium'],
  };

  const getSynonyms = (word) => {
    const normalized = normalizeText(word);
    for (const [key, variations] of Object.entries(categorySynonyms)) {
      if (variations.some(v => normalizeText(v) === normalized)) {
        return variations.map(v => normalizeText(v));
      }
    }
    return [normalized];
  };

  const calculateCategoryRelevance = (categoryTitle, query, productCount) => {
    const titleNorm = normalizeText(categoryTitle);
    const queryNorm = normalizeText(query);
    const queryWords = queryNorm.split(/[\s-]+/).filter(w => w.length >= 2);

    let score = 0;

    if (titleNorm === queryNorm) score += 1000;
    if (titleNorm.startsWith(queryNorm)) score += 500;
    if (titleNorm.includes(queryNorm)) score += 300;

    queryWords.forEach(word => {
      const synonyms = getSynonyms(word);
      synonyms.forEach(syn => {
        if (titleNorm.includes(syn)) score += 100;
        if (titleNorm.startsWith(syn)) score += 50;
      });
    });

    for (const [intent, keywords] of Object.entries(categoryIntents)) {
      const intentMatch = keywords.some(kw => queryNorm.includes(normalizeText(kw)));
      const categoryMatch = keywords.some(kw => titleNorm.includes(normalizeText(kw)));
      if (intentMatch && categoryMatch) score += 200;
    }

    queryWords.forEach(word => {
      if (titleNorm.includes(word)) score += 50;
    });

    const titleWords = titleNorm.split(/[\s-]+/).filter(w => w.length >= 2);
    const matchedWords = titleWords.filter(tw =>
      queryWords.some(qw => tw.includes(qw) || qw.includes(tw) ||
        getSynonyms(qw).some(syn => tw.includes(syn)))
    );

    const specificityRatio = matchedWords.length / titleWords.length;
    if (specificityRatio >= 0.5 && titleWords.length > 1) {
      score += specificityRatio * 150;
      if (titleWords.length >= queryWords.length) score += 100;
    }

    score += Math.min(productCount * 2, 50);

    return score;
  };

  // ===== TYPESENSE API =====

  const searchTypesense = async (query) => {
    if (!query || query.length < config.minChars) {
      return null;
    }

    const params = new URLSearchParams({
      q: query,
      query_by: 'title,variant_title,description,tags,vendor,product_type,barcode,sku',
      query_by_weights: '5,4,2,1,1,1,3,3',
      // Reviews break ties only after relevance and interaction popularity.
      sort_by: '_text_match:desc,popularity:desc,review_count:desc',
      num_typos: '2',
      typo_tokens_threshold: '1',
      drop_tokens_threshold: '2',
      prioritize_exact_match: 'true',
      filter_by: 'available:true',
      per_page: config.resultsPerPage.toString(),
      highlight_full_fields: 'title',
      highlight_start_tag: '<mark class="ais-Highlight-highlighted">',
      highlight_end_tag: '</mark>'
    });

    try {
      const response = await fetch(
        `${config.protocol}://${config.host}:${config.port}/collections/${config.collection}/documents/search?${params}`,
        {
         headers: {
  'X-TYPESENSE-API-KEY': config.apiKey,
  'X-TYPESENSE-USER-ID': getUserId(),
}
        }
      );

      if (!response.ok) {
        throw new Error(`Typesense error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Typesense search error:', error);
      return null;
    }
  };

  // ===== RENDER FUNCTIONS =====

  const renderRatingBadge = (rating, count) => {
    if (!count || count <= 0 || !rating || rating <= 0) return '';
const avg = Math.floor(rating * 10) / 10;    return `
      <div class="rating-badge-wrapper rating-badge-wrapper--compact">
        <div class="rating-badge">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="rating-badge__star-icon" aria-hidden="true">
            <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd"/>
          </svg>
          <span class="rating-badge__score">${avg}</span>
        </div>
      </div>
    `;
  };

  const iconPlusSvg = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus icon--small icon--thick" fill="none" viewBox="0 0 20 20"><path d="M3.125 10H16.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 3.125V16.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const iconCartSvg = `<svg viewBox="0 0 20 20" fill="none" class="icon icon-shopping-bag icon--small icon--thick" xmlns="http://www.w3.org/2000/svg"><path d="M6.875 18.125C7.56536 18.125 8.125 17.5654 8.125 16.875C8.125 16.1846 7.56536 15.625 6.875 15.625C6.18464 15.625 5.625 16.1846 5.625 16.875C5.625 17.5654 6.18464 18.125 6.875 18.125Z" fill="currentColor"/><path d="M15 18.125C15.6904 18.125 16.25 17.5654 16.25 16.875C16.25 16.1846 15.6904 15.625 15 15.625C14.3096 15.625 13.75 16.1846 13.75 16.875C13.75 17.5654 14.3096 18.125 15 18.125Z" fill="currentColor"/><path d="M1.25 2.5H3.125L5.99609 12.8344C6.06916 13.0976 6.22643 13.3296 6.44384 13.4949C6.66126 13.6603 6.92685 13.7499 7.2 13.75H14.9219C15.1952 13.7501 15.4609 13.6605 15.6785 13.4952C15.8961 13.3298 16.0535 13.0977 16.1266 12.8344L18.125 5.625H3.99297" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  // ===== FEATURE ICONS (matches pcard-feature-icons.liquid) =====

  const FEATURE_ICONS_MAP = {
    biologisch: { label: 'Biologisch', file: 'Biologisch.svg' },
    eko: { label: 'Eko', file: 'Eko-keurmerk.svg' },
    cosmos_organic: { label: 'Cosmos Organic', file: 'Cosmos.svg' },
    demeter: { label: 'Demeter', file: 'Demeter.svg' },
    msc: { label: 'MSC', file: 'MSC.svg' },
    vegan: { label: 'Vegan', file: 'Vegan.svg' },
    glutenvrij: { label: 'Glutenvrij', file: 'Glutenvrij.svg' },
    lactosevrij: { label: 'Lactosevrij', file: 'Lactosevrij.svg' },
    suikervrij: { label: 'Suikervrij', file: 'Suikervrij.svg' },
    zoutarm: { label: 'Zoutarm', file: 'Zoutarm.svg' },
    gistvrij: { label: 'Gistvrij', file: 'Gistvrij.svg' },
    alcoholvrij: { label: 'Alcoholvrij', file: 'Alcoholvrij.svg' },
    raw: { label: 'Raw', file: 'Raw.svg' },
    spf_50_plus: { label: 'SPF 50+', file: 'SPF_50_plus.svg' },
    spf_60: { label: 'SPF 60', file: 'SPF 60.svg' },
    spf_50: { label: 'SPF 50', file: 'SPF 50.svg' },
    spf_30_plus: { label: 'SPF 30+', file: 'SPF_30_plus.svg' },
    spf_30: { label: 'SPF 30', file: 'SPF 30.svg' },
    spf_25: { label: 'SPF 25', file: 'SPF 25.svg' },
    spf_20: { label: 'SPF 20', file: 'SPF 20.svg' },
    spf_15_plus: { label: 'SPF 15+', file: 'SPF_15_plus.svg' },
    spf_15: { label: 'SPF 15', file: 'SPF 15.svg' },
    spf_10: { label: 'SPF 10', file: 'SPF 10.svg' },
    parfumvrij: { label: 'Parfumvrij', file: 'Parfumvrij.svg' },
    microplasticvrij: { label: 'Microplasticvrij', file: 'Microplasticvrij.svg' }
  };

  const FEATURE_ICON_KEYS = Object.keys(FEATURE_ICONS_MAP);

  const renderFeatureIcons = (hit) => {
    const assetBase = config.assetBaseUrl || (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.asset_base_url) || '';
const iconKeys = (hit.feature_icons || []).filter(key => FEATURE_ICONS_MAP[key]);    if (iconKeys.length === 0) return '';

    const iconsHtml = iconKeys.slice(0, 5).map(key => {
      const icon = FEATURE_ICONS_MAP[key];
      const assetUrl = `${assetBase}${encodeURIComponent(icon.file)}`;
      return `
        <div class="pcard-feature-icons__item">
          <img src="${assetUrl}" alt="${icon.label}" width="24" height="24" loading="lazy" decoding="async">
          <span class="pcard-feature-icons__tooltip">${icon.label}<span class="pcard-feature-icons__tooltip-arrow"></span></span>
        </div>
      `;
    }).join('');

    return `<div class="pcard-feature-icons" aria-label="Productkenmerken">${iconsHtml}</div>`;
  };

  // Badges: matches pcard-badges.liquid (sale/new/hot/soldout in product-card__badge wrapper)
  const renderPcardBadges = (hit) => {
    const isInStock = hit.in_stock !== undefined ? hit.in_stock : hit.available !== false;
    const isOnSale = !hit.uad && hit.compare_at_price && hit.compare_at_price > hit.price;
    let badges = '';

    if (!isInStock) {
      badges += '<span class="f-badge f-badge--soldout" aria-hidden="true">Uitverkocht</span>';
    }

    if (isOnSale && isInStock) {
      const amount = Math.round(((hit.compare_at_price - hit.price) / hit.compare_at_price) * 100);
      badges += `<span class="f-badge f-badge--sale" aria-hidden="true">-${amount}%</span>`;
    }

    return badges ? `<div class="product-card__badge">${badges}</div>` : '';
  };

  const renderProductCard = (hit) => {
    const price = hit.price ? `€${hit.price.toFixed(2)}` : 'Prijs niet beschikbaar';
    const isOnSale = !hit.uad && hit.compare_at_price && hit.compare_at_price > hit.price;
    const comparePrice = isOnSale ? `€${hit.compare_at_price.toFixed(2)}` : '';
    const variantParam = hit.variant_id ? `?variant=${hit.variant_id}` : '';
    const productUrl = `${config.shopUrl}/products/${hit.handle}${variantParam}`;
    const isInStock = hit.in_stock !== undefined ? hit.in_stock : hit.available !== false;

    const highlightedTitle = hit.highlights?.find(h => h.field === 'title')?.snippet || escapeHtml(hit.document?.title || hit.title);

    const vendorHandle = hit.vendor
      ? hit.vendor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
      : '';

    let inventoryStatus = '';
    let inventoryMessage = '';
    if (isInStock) {
      inventoryStatus = 'in-stock';
      inventoryMessage = 'Op voorraad';
    } else {
      inventoryStatus = 'out-of-stock';
      inventoryMessage = 'Niet op voorraad';
    }

    const pcardStyle = config.pcardStyle || 'standard';
    const pcardColorScheme = config.pcardColorScheme || 'scheme-1';
    const titleLineLimit = config.pcardTitleLineLimit || 'none';
    const colorClass = pcardStyle === 'card' ? ` color-${pcardColorScheme}` : '';
    const titleLimitClass = titleLineLimit !== 'none' ? ` text-limit-${titleLineLimit}` : '';

    // Exact same structure as card-product.liquid:
    // 1. image-wrapper contains: wishlist-button, feature-icons, <a> with image, pcard-badges
    // 2. product-card__info contains: meta, title, spacer, price-wrapper (with free shipping label), bottom-row
    return `
      <li class="search-hit-item">
        <div class="product-card product-card-style-${pcardStyle}${colorClass}" data-product-id="${escapeHtml(hit.id)}" data-product-vendor="${escapeHtml(vendorHandle)}">
          <div class="product-card__wrapper h-full">
                    <div class="product-card__image-wrapper product-card__image-wrapper--main-only">
              <wishlist-button data-product-handle="${escapeHtml(hit.handle)}"></wishlist-button>
              ${renderFeatureIcons(hit)}
              <a data-ts-product-link href="${escapeHtml(productUrl)}" aria-label="${escapeHtml(hit.title)}" tabindex="-1">
                <motion-element data-motion="zoom-out-sm" class="block">
                  <div class="media-wrapper product-card__image product-card__image--main" style="--aspect-ratio: 1">
                    ${hit.image_url
                      ? `<img src="${escapeHtml(hit.image_url)}" alt="${escapeHtml(hit.title)}" loading="lazy" class="motion-reduce" fetchpriority="low">`
                      : `<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525 525">
                          <rect fill="#f3f4f6" width="100%" height="100%"/>
                          <text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#9ca3af" font-size="18">Geen afbeelding</text>
                        </svg>`
                    }
                  </div>
                </motion-element>
              </a>
            </div>

            <div class="product-card__info text-left">
              <div class="product-card__meta">
                <div class="product-card__meta-left">
                  ${hit.vendor ? `
                    <p class="product-card__vendor text-sm-extra m-0">
                      <a href="/collections/${escapeHtml(vendorHandle)}" class="reversed-link" aria-label="Vendor ${escapeHtml(hit.vendor)}">
                        ${escapeHtml(hit.vendor)}
                      </a>
                    </p>
                  ` : ''}
                </div>
                ${renderRatingBadge(hit.review_rating, hit.review_count)}
              </div>

              <h3 class="product-card__title text-pcard-title">
                <a data-ts-product-link class="reversed-link block${titleLimitClass}" href="${escapeHtml(productUrl)}">
                  <span class="reversed-link__text">${highlightedTitle}</span>
                </a>
              </h3>

              <div class="product-card__spacer"></div>

              <div class="product-card__price-wrapper">
                <div class="f-price f-price--left ${isOnSale ? 'f-price--on-sale' : ''}">
                  ${!isOnSale ? `
                    <div class="f-price__regular">
                      <span class="visually-hidden visually-hidden--inline">Normale prijs</span>
                      <span class="f-price-item f-price-item--regular">${price}</span>
                    </div>
                  ` : `
                    <div class="f-price__sale">
                      <span class="visually-hidden visually-hidden--inline">Normale prijs</span>
                      <span class="f-price-item f-price-item--regular">
                        ${comparePrice} <span class="f-price-item--advice-label">(adviesprijs)</span>
                      </span>
                      <span class="price-tooltip-wrapper price-tooltip-wrapper--inline">
                        <button type="button" class="price-tooltip-trigger" aria-label="Adviesprijs informatie">
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="7.5" stroke="currentColor"/>
                            <text x="8" y="11" text-anchor="middle" font-size="10" fill="currentColor" font-weight="bold">i</text>
                          </svg>
                        </button>
                        <div class="price-tooltip" role="tooltip" aria-hidden="true">
                          Adviesprijs van ${escapeHtml(hit.vendor || 'de fabrikant')}.
                          <a href="/pages/adviesprijzen-en-kortingscodes" class="price-tooltip-link">Klik hier voor meer informatie.</a>
                        </div>
                      </span>
                      <span class="visually-hidden visually-hidden--inline">Aanbiedingsprijs</span>
                      <span class="f-price-item f-price-item--sale">${price}</span>
                    </div>
                  `}
                </div>
                ${hit.free_shipping === true ? '<span class="pcard-free-shipping-label">Gratis verzending</span>' : ''}
              </div>

              <div class="product-card__bottom-row">
                ${inventoryStatus ? `
                  <span class="product-card__inventory-dot product-card__inventory-dot--${inventoryStatus}">
                    <span class="product-card__inventory-dot-icon"></span>
                    <span class="product-card__inventory-dot-text">${inventoryMessage}</span>
                  </span>
                ` : ''}
                ${isInStock ? `
                  <button
                    type="button"
                    class="pcard-cart-btn btn btn--primary"
                    data-product-url="${escapeHtml(productUrl)}"
                    data-product-handle="${escapeHtml(hit.handle)}"
                    ${hit.variant_id ? `data-variant-id="${escapeHtml(hit.variant_id)}"` : ''}
                    aria-label="Toevoegen aan winkelwagen"
                  >
                    <span class="btn__text flex items-center gap-1">
                      ${iconPlusSvg}
                      ${iconCartSvg}
                    </span>
                  </button>
                ` : ''}
              </div>
            </div>
          </div>
        </div>
      </li>
    `;
  };

  const renderResults = (results, query) => {
    if (!results || !results.hits || results.hits.length === 0) {
      hitsContainer.innerHTML = `
        <li class="search-hit-item search-hit-item--empty">
          <div class="empty-state">
            <h4>Geen resultaten gevonden voor "${escapeHtml(query)}"</h4>
            <p class="m-0 text-subtext">Controleer de spelling of probeer een andere zoekterm.</p>
          </div>
        </li>
      `;
      statsContainer.innerHTML = '';
      viewAllContainer.innerHTML = '';
      if (suggestionsContainer) suggestionsContainer.innerHTML = '';
      if (collectionsContainer) collectionsContainer.innerHTML = '';
      if (brandsList) brandsList.innerHTML = '';
      if (categoriesList) categoriesList.innerHTML = '';

      trackSearchResultsView(query, 0);

      return;
    }

    hitsContainer.innerHTML = results.hits.map(hit => renderProductCard(hit.document || hit)).join('');

    const count = results.found || results.hits.length;
    statsContainer.innerHTML = `
      <div class="search-stats">
        ${count} ${count === 1 ? 'product' : 'producten'} gevonden voor "${escapeHtml(query)}"
      </div>
    `;

    if (count > 0) {
      const searchUrl = `${config.shopUrl}/search?q=${encodeURIComponent(query)}&type=product`;
      viewAllContainer.innerHTML = `
        <a href="${escapeHtml(searchUrl)}" class="view-all-button">
          Bekijk alle ${count} resultaten →
        </a>
      `;
    } else {
      viewAllContainer.innerHTML = '';
    }

    renderSuggestions(results.hits, query);
    renderCollections(results.hits, query);
    renderBrands(results.hits);
    renderCategories(results.hits, query);

    trackSearchResultsView(query, count);

    // Click on a result: GTM select_search_result + Typesense products_click_event
    // (feeds the popularity counter of the collection).
    hitsContainer.querySelectorAll('.product-card').forEach((card) => {
      card.addEventListener('click', (e) => {
        // Only the image and title navigate to the product. Other card interactions
        // (vendor, wishlist, add-to-cart or whitespace) are not product selections.
        const productLink = e.target.closest('a[data-ts-product-link]');
        if (!productLink || !card.contains(productLink)) return;

        const productId = card.dataset.productId;
        if (productId) {
          pushToDataLayer('select_search_result', {
            search_term: query,
            content_id: String(productId)
          });
          trackProductClick(productId);
        }
      });
    });
  };

  const renderSuggestions = (hits, query) => {
    if (!suggestionsContainer) return;

    const queryLower = query.toLowerCase().trim();
    const suggestions = new Set();

    hits.forEach(hit => {
      const doc = hit.document || hit;
      const title = (doc.title || '').toLowerCase();

      if (!title.includes(queryLower)) return;

      const words = title.split(/\s+/).filter(w => w.length > 2 && !/\d/.test(w));

      for (let i = 0; i < words.length - 1; i++) {
        const phrase = `${words[i]} ${words[i + 1]}`;
        if (phrase.includes(queryLower) && phrase !== queryLower && phrase.length <= 30) {
          suggestions.add(phrase);
        }
      }

      for (let i = 0; i < words.length - 2; i++) {
        const phrase = `${words[i]} ${words[i + 1]} ${words[i + 2]}`;
        if (phrase.includes(queryLower) && phrase !== queryLower && phrase.length <= 40) {
          suggestions.add(phrase);
        }
      }
    });

    const sortedSuggestions = Array.from(suggestions)
      .sort((a, b) => {
        const aStarts = a.startsWith(queryLower);
        const bStarts = b.startsWith(queryLower);
        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;
        return a.length - b.length;
      })
      .slice(0, 6);

    if (sortedSuggestions.length > 0) {
      suggestionsContainer.innerHTML = `
        <ul>
          ${sortedSuggestions.map(phrase => `
            <li>
              <a href="#" class="suggestion-link" data-query="${escapeHtml(phrase)}">
                ${escapeHtml(phrase)}
              </a>
            </li>
          `).join('')}
        </ul>
      `;

      suggestionsContainer.querySelectorAll('.suggestion-link').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const newQuery = link.dataset.query;
          searchInput.value = newQuery;
          performSearch(newQuery);
        });
      });
    } else {
      suggestionsContainer.innerHTML = '';
    }
  };

  const renderCollections = (hits, query) => {
    if (!collectionsContainer) return;

    const collectionsMap = new Map();

    hits.forEach(hit => {
      const doc = hit.document || hit;
      if (doc.collections && Array.isArray(doc.collections)) {
        doc.collections.forEach((collectionTitle, idx) => {
          const collectionHandle = doc.collection_handles?.[idx];
          if (collectionTitle && collectionHandle) {
            if (!collectionsMap.has(collectionHandle)) {
              collectionsMap.set(collectionHandle, {
                title: collectionTitle,
                handle: collectionHandle,
                count: 0,
                relevance: 0
              });
            }
            collectionsMap.get(collectionHandle).count++;
          }
        });
      }
    });

    const excludePatterns = [
      /^tax/i, /^best-/i, /^newest/i, /^new-/i, /^all$/i, /^all-/i,
      /hidden/i, /^featured/i, /^sale$/i, /^frontpage/i,
      /^vendor-/i, /^type-/i, /-tax$/i, /percentage/i
    ];

    const relevantCollections = Array.from(collectionsMap.values())
      .map(col => {
        col.relevance = calculateCategoryRelevance(col.title, query, col.count);
        return col;
      })
      .filter(col => {
        const title = normalizeText(col.title);
        const handle = normalizeText(col.handle);
        if (excludePatterns.some(pattern => pattern.test(title) || pattern.test(handle))) {
          return false;
        }
        return col.relevance > 0;
      })
      .sort((a, b) => b.relevance - a.relevance)
      .slice(0, 6);

    if (relevantCollections.length > 0) {
      collectionsContainer.innerHTML = `
        <ul>
          ${relevantCollections.map(col => `
            <li>
              <a href="${config.shopUrl}/collections/${escapeHtml(col.handle)}">
                ${escapeHtml(col.title)}
              </a>
            </li>
          `).join('')}
        </ul>
      `;
    } else {
      collectionsContainer.innerHTML = '';
    }
  };

  const renderBrands = (hits) => {
    if (!brandsList) return;

    const vendorsMap = new Map();
    hits.forEach(hit => {
      const doc = hit.document || hit;
      if (doc.vendor) {
        const vendor = doc.vendor.trim();
        if (!vendorsMap.has(vendor)) {
          vendorsMap.set(vendor, { name: vendor, count: 0 });
        }
        vendorsMap.get(vendor).count++;
      }
    });

    const sortedVendors = Array.from(vendorsMap.values())
      .sort((a, b) => b.count - a.count)
      .slice(0, 20);

    if (sortedVendors.length > 0) {
      brandsList.innerHTML = sortedVendors.map(vendor => `
        <a href="${config.shopUrl}/collections/${vendor.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}">
          ${escapeHtml(vendor.name)}
        </a>
      `).join('');
    } else {
      brandsList.innerHTML = '<p style="text-align: center; padding: 3rem; color: #6b7280;">Geen merken gevonden</p>';
    }
  };

  const renderCategories = (hits, query) => {
    if (!categoriesList) return;

    const collectionsMap = new Map();
    hits.forEach(hit => {
      const doc = hit.document || hit;
      if (doc.collections && Array.isArray(doc.collections)) {
        doc.collections.forEach((collectionTitle, idx) => {
          const collectionHandle = doc.collection_handles?.[idx];
          if (collectionTitle && collectionHandle) {
            if (!collectionsMap.has(collectionHandle)) {
              collectionsMap.set(collectionHandle, {
                title: collectionTitle,
                handle: collectionHandle,
                count: 0,
                relevance: 0
              });
            }
            collectionsMap.get(collectionHandle).count++;
          }
        });
      }
    });

    const excludePatterns = [
      /^tax/i, /^best-/i, /^newest/i, /^new-/i, /^all$/i, /^all-/i,
      /hidden/i, /^featured/i, /^sale$/i, /^frontpage/i,
      /^vendor-/i, /^type-/i, /-tax$/i, /percentage/i
    ];

    const sortedCollections = Array.from(collectionsMap.values())
      .map(col => {
        col.relevance = calculateCategoryRelevance(col.title, query, col.count);
        return col;
      })
      .filter(col => {
        const title = normalizeText(col.title);
        const handle = normalizeText(col.handle);
        if (excludePatterns.some(pattern => pattern.test(title) || pattern.test(handle))) {
          return false;
        }
        return col.relevance > 0;
      })
      .sort((a, b) => b.relevance - a.relevance)
      .slice(0, 15);

    if (sortedCollections.length > 0) {
      categoriesList.innerHTML = sortedCollections.map(col => `
        <a href="${config.shopUrl}/collections/${escapeHtml(col.handle)}">
          ${escapeHtml(col.title)}
        </a>
      `).join('');
    } else {
      categoriesList.innerHTML = '<p style="text-align: center; padding: 3rem; color: #6b7280;">Geen categorieën gevonden</p>';
    }
  };

  // ===== UI STATE MANAGEMENT =====

  const showResults = () => {
    document.body.classList.add('advanced-search-open');
    resultsContainer.removeAttribute('hidden');
    resultsContainer.classList.remove('search-results-hidden');
    resultsContainer.classList.add('search-results-visible');
    searchWrapper.classList.add('overlay-active');

    if (closeButtonMobile) {
      closeButtonMobile.style.display = 'flex';
    }

    updateHeaderHeight();
  };

  const hideResults = () => {
    document.body.classList.remove('advanced-search-open');
    resultsContainer.classList.add('search-results-hidden');
    resultsContainer.classList.remove('search-results-visible');
    searchWrapper.classList.remove('overlay-active');

    if (closeButtonMobile) {
      closeButtonMobile.style.display = 'none';
    }
  };

  const closeSearch = () => {
    hideResults();
    searchInput.value = '';
    lastTrackedSearchEventKey = '';
    hitsContainer.innerHTML = '';
    statsContainer.innerHTML = '';
    viewAllContainer.innerHTML = '';
    if (suggestionsContainer) suggestionsContainer.innerHTML = '';
    if (collectionsContainer) collectionsContainer.innerHTML = '';
    if (brandsList) brandsList.innerHTML = '';
    if (categoriesList) categoriesList.innerHTML = '';
  };

  // ===== HEADER HEIGHT TRACKING =====

  let lastHeaderHeight = 0;
  const updateHeaderHeight = () => {
    const header = document.querySelector('.shopify-section-header')
      || document.querySelector('header')
      || document.querySelector('[role="banner"]');

    if (header) {
      const headerHeight = header.offsetHeight;
      if (headerHeight !== lastHeaderHeight) {
        lastHeaderHeight = headerHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      }
    }
  };

  // ===== SEARCH EXECUTION =====

  const performSearch = async (query) => {
    if (!query || query.length < config.minChars) {
      hideResults();
      searchWrapper?.classList.remove('ts-loading');
      return;
    }

    showResults();

    searchWrapper?.classList.add('ts-loading');
    resultsContainer?.classList.add('ts-loading');

    if (!hitsContainer.children.length) {
      hitsContainer.innerHTML = '<li class="search-hit-item search-hit-item--loading" style="grid-column: 1/-1; text-align: center; padding: 4rem;"><p>Zoeken...</p></li>';
    }

    const results = await searchTypesense(query);

    searchWrapper?.classList.remove('ts-loading');
    resultsContainer?.classList.remove('ts-loading');

    if (results) {
      lastSearchQuery = query;
      renderResults(results, query);
    }
  };

  const debouncedSearch = debounce(performSearch, 150);

  // ===== EVENT LISTENERS =====

  searchInput.addEventListener('input', (e) => {
    const query = e.target.value.trim();
    if (normalizeText(query).length < minTrackedSearchChars) {
      lastTrackedSearchEventKey = '';
    }
    debouncedSearch(query);
  });

  searchInput.addEventListener('focus', () => {
    updateHeaderHeight();
    const query = searchInput.value.trim();
    if (query && query.length >= config.minChars) {
      showResults();
    }
  });

  if (resetButton) {
    resetButton.addEventListener('click', closeSearch);
  }

  if (closeButtonDesktop) {
    closeButtonDesktop.addEventListener('click', closeSearch);
  }

  if (closeButtonMobile) {
    closeButtonMobile.addEventListener('click', closeSearch);
  }

  document.addEventListener('click', (e) => {
    if (!resultsContainer.classList.contains('search-results-visible')) return;

    const clickedInsideSearch = e.target.closest('#typesense-search-wrapper, #typesense-results-container, #typesense-searchbox, #typesense-search-placeholder');
    if (!clickedInsideSearch) {
      closeSearch();
    }
  });

  document.addEventListener('click', async (e) => {
    const addToCartBtn = e.target.closest('#typesense-results-container .pcard-cart-btn');
    if (!addToCartBtn) return;

    e.preventDefault();
    e.stopPropagation();
    
    const productUrl = addToCartBtn.dataset.productUrl;
    const productHandle = addToCartBtn.dataset.productHandle;
    const variantId = addToCartBtn.dataset.variantId;

    if (!productHandle) {
      window.location.href = productUrl;
      return;
    }

    addToCartBtn.classList.add('is-loading');
    addToCartBtn.disabled = true;

    try {
      let cartVariantId;

      if (variantId) {
        cartVariantId = variantId;
      } else {
        const productResponse = await fetch(`${config.shopUrl}/products/${productHandle}.js`);
        const productData = await productResponse.json();
        const availableVariant = productData.variants.find(v => v.available) || productData.variants[0];
        if (!availableVariant) throw new Error('No variant available');
        cartVariantId = availableVariant.id;
      }
      // ... rest met id: cartVariantId

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const response = await fetch(`${config.shopUrl}/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: cartVariantId,
          quantity: 1,
          sections: sectionsToBundle.length > 0 ? sectionsToBundle : undefined,
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const parsedState = await response.json();

      const cartResponse = await fetch(`${config.shopUrl}/cart.js`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const cartJson = await cartResponse.json();

      if (parsedState.sections) {
        cartJson.sections = parsedState.sections;
      }

      const cartCountEl = document.querySelector('cart-count');
      if (cartCountEl) {
        cartCountEl.textContent = cartJson.item_count;
        cartCountEl.removeAttribute('hidden');
      }

      if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      }

      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: { product: parsedState }
      }));

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        setTimeout(() => {
          cartDrawer.show();
        }, 100);
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { open: true }
        }));
      }

    } catch (error) {
      console.error('Add to cart error:', error);
      window.location.href = productUrl;
    } finally {
      addToCartBtn.classList.remove('is-loading');
      addToCartBtn.disabled = false;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && resultsContainer.classList.contains('search-results-visible')) {
      closeSearch();
    }
  });

  const tabs = document.querySelectorAll('.mobile-tab');
  const tabContents = document.querySelectorAll('.tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetTab = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove('mobile-tab--active'));
      tabContents.forEach(c => c.classList.remove('tab-content--active'));

      tab.classList.add('mobile-tab--active');

      const targetContent = document.getElementById(`tab-${targetTab}`);
      if (targetContent) {
        targetContent.classList.add('tab-content--active');
      }
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeaderHeight, 100);
  });

  let scrollTimer;
  let isScrolling = false;
  window.addEventListener('scroll', () => {
    if (!isScrolling) {
      isScrolling = true;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        updateHeaderHeight();
        isScrolling = false;
      }, 100);
    }
  }, { passive: true });

  const updateResetButton = () => {
    if (resetButton) {
      resetButton.style.opacity = searchInput.value ? '1' : '0';
    }
  };

  searchInput.addEventListener('input', updateResetButton);
  updateResetButton();

  updateHeaderHeight();

})();
